import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"info\"><g data-name=\"Icons-/-Large-/-Primary-/-Information\"><path d=\"M12 24a12 12 0 1 1 12-12 12 12 0 0 1-12 12zm0-21.82A9.82 9.82 0 1 0 21.82 12 9.84 9.84 0 0 0 12 2.18z\" /><path d=\"M12 17.45a1.09 1.09 0 0 1-1.09-1.09V12a1.09 1.09 0 0 1 2.18 0v4.36A1.09 1.09 0 0 1 12 17.45zM12 9.31a1.09 1.09 0 0 1-1.09-1.09v-.58a1.09 1.09 0 0 1 2.18 0v.58A1.09 1.09 0 0 1 12 9.31z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol